/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_PlayingInputs */

const th_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังเล่น`)
};

const en_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playing`)
};

const ja_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生中`)
};

const zh_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`播放中`)
};

const es_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduciendo`)
};

const pt_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduzindo`)
};

const id_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berjalan`)
};

const fr_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture`)
};

const tl_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umaandar`)
};

const vi_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang chạy`)
};

const ko_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`재생 중`)
};

const de_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft`)
};

const ru_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идёт`)
};

const tr_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oynatılıyor`)
};

const it_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In riproduzione`)
};

const pl_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odtwarzanie`)
};

const uk_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відтворюється`)
};

const hi_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चल रहा है`)
};

const ar_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قيد التشغيل`)
};

const ms_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang bermain`)
};

const bn_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চলছে`)
};

const zh_tw2_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`播放中`)
};

const zh_hk2_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`播放中`)
};

const ur_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چل رہا ہے`)
};

const fa_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال پخش`)
};

const sw_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inacheza`)
};

const nl_video_playing = /** @type {(inputs: Video_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speelt`)
};

/**
* | output |
* | --- |
* | "Playing" |
*
* @param {Video_PlayingInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_playing = /** @type {((inputs?: Video_PlayingInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_PlayingInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_playing(inputs)
	if (locale === "ja") return ja_video_playing(inputs)
	if (locale === "zh") return zh_video_playing(inputs)
	if (locale === "es") return es_video_playing(inputs)
	if (locale === "pt") return pt_video_playing(inputs)
	if (locale === "id") return id_video_playing(inputs)
	if (locale === "fr") return fr_video_playing(inputs)
	if (locale === "tl") return tl_video_playing(inputs)
	if (locale === "vi") return vi_video_playing(inputs)
	if (locale === "ko") return ko_video_playing(inputs)
	if (locale === "de") return de_video_playing(inputs)
	if (locale === "ru") return ru_video_playing(inputs)
	if (locale === "tr") return tr_video_playing(inputs)
	if (locale === "it") return it_video_playing(inputs)
	if (locale === "pl") return pl_video_playing(inputs)
	if (locale === "uk") return uk_video_playing(inputs)
	if (locale === "hi") return hi_video_playing(inputs)
	if (locale === "ar") return ar_video_playing(inputs)
	if (locale === "ms") return ms_video_playing(inputs)
	if (locale === "bn") return bn_video_playing(inputs)
	if (locale === "zh-TW") return zh_tw2_video_playing(inputs)
	if (locale === "zh-HK") return zh_hk2_video_playing(inputs)
	if (locale === "ur") return ur_video_playing(inputs)
	if (locale === "fa") return fa_video_playing(inputs)
	if (locale === "sw") return sw_video_playing(inputs)
	if (locale === "nl") return nl_video_playing(inputs)
	return en_video_playing(inputs)
});